import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";

import type { ComparisonRelation } from "./generatorStatusDisplay";

/** Marks a calculated status above or below the reported one; the label carries the meaning. */
export function ComparisonArrow({ relation }: { relation?: ComparisonRelation }) {
  if (relation === "ABOVE") {
    return <ArrowUpward sx={{ fontSize: 16, color: "warning.main" }} />;
  }
  if (relation === "BELOW") {
    return <ArrowDownward sx={{ fontSize: 16, color: "text.secondary" }} />;
  }
  return null;
}
